export enum JobApplicationStep {
  CANDIDATE = 1,
  DETAILS = 2,
  FILES = 3,
  QUESTIONNAIRE = 4,
  WORKSTYLES = 5,
  SUMMARY = 6,
}
